import { render, staticRenderFns } from "./table-history.vue?vue&type=template&id=0bdd5058"
import script from "./table-history.vue?vue&type=script&lang=js"
export * from "./table-history.vue?vue&type=script&lang=js"
import style0 from "./table-history.vue?vue&type=style&index=0&id=0bdd5058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports